<template>
  <div>
    <div v-if="isLoading">
      <div class="pt-3 pb-5">
        <news-feed-loading-skeleton :count="loadingSkeletonCount" />
      </div>
    </div>
    <div v-else>
      <div class="row pt-4">
        <div class="col-12 col-xl-9">
          <div v-html="title"></div>
        </div>
        <div class="col-12 col-xl-3 pt-2 pt-xl-1 d-flex justify-content-xl-end">
          <div v-if="enableEditInterests">
            <edit-interests-button :topics="topics" />
          </div>
          <div v-else>
            <summarize-news-button />
          </div>
        </div>
      </div>
      <div v-if="!enableEditInterests" class="row pt-4 pb-3">
        <div class="col-12 col-xl-12">
          <news-feed-filters />
        </div>
      </div>
      <div class="alert alert-warning" v-if="isErrored">
        {{ CONSTANTS.INTEGRATED_SYS_ERROR_WARNING }}
      </div>
      <div v-else>
        <div v-if="isFilteredSearchLoading" class="load-more-wrapper d-flex justify-content-center pb-4">
            <div class="d-flex justify-content-center pb-4">
              <div class="more-loading-spinner">
                <img :src="spinnerUrl" alt="Loading Spinner" />
              </div>
            </div>
        </div>
        <div v-else>
          <div class="mt-md-1" v-if="posts && posts.length > 0">
            <div v-for="post in posts" :key="post.id">
              <div class="pb-md-3">
                <news-feed-card
                  :post-data="post"
                  :show-interest-tag="enableEditInterests"
                />
              </div>
            </div>
            <div v-if="enableLoadMore" class="load-more-wrapper d-flex justify-content-center pb-4">
              <div class="d-flex justify-content-center pb-4">
                <div v-if="isMoreLoading" class="more-loading-spinner">
                  <img src="@/assets/spinner.svg" alt="Loading Spinner" />
                </div>
                <div
                  v-else-if="showLoadMore"
                  class="homebase-btn-secondary"
                  @click="onLoadMoreClicked">
                  Load more
                </div>
              </div>
            </div>
          </div>
          <div v-else class="mt-4">No news to display</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as CONSTANTS from "@/store/constants";
import NewsFeedCard from "./NewsFeedCard";
import EditInterestsButton from "./EditInterestsButton";
import NewsFeedLoadingSkeleton from "./NewsFeedLoadingSkeleton";
import SummarizeNewsButton from '../buttons/SummarizeNewsButton';
import NewsFeedFilters from "../news/NewsFeedFilters.vue";

export default {
  name: "news-feed",
  props: [
    "isLoading",
    "title",
    "posts",
    "topics",
    "isFullPage",
    "enableEditInterests",
    "isErrored",
    "message",
    "enableLoadMore",
    "showLoadMore",
    "isMoreLoading",
    "isFilteredSearchLoading",
  ],
  components: {
    NewsFeedCard,
    NewsFeedFilters,
    NewsFeedLoadingSkeleton,
    EditInterestsButton,
    SummarizeNewsButton
  },
  data() {
    return {
      CONSTANTS,
      spinnerUrl: HH_COMPONENTS_URL + "/spinner.svg"
    };
  },
  computed: {
    loadingSkeletonCount() {
      return this.isFullPage ? 7 : 3;
    },
  },
  methods: {
    onLoadMoreClicked() {
      this.$emit("onLoadMore");
    },
  },
};
</script>

<style scoped>
.msg-wrapper {
  min-height: 16px;
}
.more-loading-spinner img {
  height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/homebase/newsByInterests/NewsFeed.vue